import type { TypePolicies } from '../../../../utils/types/TypePolicies';
import { userPrefsMap } from '../user-prefs';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      getUserPrefs: (_, { args }) => {
        return userPrefsMap.get(args.userId);
      },
    },
  },
};
